/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: 
 * class: EReg
 * root Object
 * @constructor
 */
window.EReg = function(r,opt) {
	opt = opt.split("u").join("");/*  'u' (utf8) depends on page encoding*/
	this.r = new RegExp(r,opt);
};
$hxClasses['EReg'] = EReg;
/** @private @type {Array} */
EReg.__name__ = ["EReg"];

/**
 * customReplace
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => f, t => TFun([{ name => , t => TInst(EReg,[]), opt => false }],TInst(String,[])), opt => false }],TInst(String,[]))
 * @public
 * @this EReg
 * @param {string}  s 
 * @param {TFun([{ name => , t => TInst(EReg,[]), opt => false }],TInst(String,[]))}  f 
 * @return {string}
 */
EReg.prototype.customReplace = function(s,f) {
	/** @type {StringBuf} */ 
	var buf = new StringBuf();
	while(true) {
		if(!this.match(s)) break;
		buf.b += Std.string(this.matchedLeft());
		buf.b += Std.string(f(this));
		s = this.matchedRight();
	}
	buf.b += Std.string(s);
	return buf.b;
};


/**
 * replace
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false },{ name => by, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @public
 * @this EReg
 * @param {string}  s 
 * @param {string}  by 
 * @return {string}
 */
EReg.prototype.replace = function(s,by) {
	return s.replace(this.r,by);
};


/**
 * split
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TInst(Array,[TInst(String,[])]))
 * @public
 * @this EReg
 * @param {string}  s 
 * @return {Array}
 */
EReg.prototype.split = function(s) {
	/** @type {string} */ 
	var d = "#__delim__#";
	return s.replace(this.r,d).split(d);
};


/**
 * matchedPos
 *
 * $type TFun([],TAnonymous(<anonymous>))
 * @public
 * @this EReg
 * @return {TAnonymous(<anonymous>)}
 */
EReg.prototype.matchedPos = function() {
	if(this.r.m == null) throw "No string matched";
	return { pos : this.r.m.index, len : this.r.m[0].length};
};


/**
 * matchedRight
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this EReg
 * @return {string}
 */
EReg.prototype.matchedRight = function() {
	if(this.r.m == null) throw "No string matched";
	/** @type {number} */ 
	var sz = this.r.m.index + this.r.m[0].length;
	return this.r.s.substr(sz,this.r.s.length - sz);
};


/**
 * matchedLeft
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this EReg
 * @return {string}
 */
EReg.prototype.matchedLeft = function() {
	if(this.r.m == null) throw "No string matched";
	return this.r.s.substr(0,this.r.m.index);
};


/**
 * matched
 *
 * $type TFun([{ name => n, t => TInst(Int,[]), opt => false }],TInst(String,[]))
 * @public
 * @this EReg
 * @param {number}  n 
 * @return {string}
 */
EReg.prototype.matched = function (n) {
	return this.r.m != null && n >= 0 && n < this.r.m.length ? this.r.m[n] : (function () {
		throw "EReg::matched";
	}(this));
};


/**
 * match
 *
 * $type TFun([{ name => s, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @this EReg
 * @param {string}  s 
 * @return {boolean}
 */
EReg.prototype.match = function(s) {
	if(this.r.global) this.r.lastIndex = 0;
	this.r.m = this.r.exec(s);
	this.r.s = s;
	return this.r.m != null;
};

/** @private @type {null} */
EReg.prototype.r = null;
/** @type {EReg} */
EReg.prototype.__class__ = EReg;
